const animatedPaths = new Set([
	'/',
	'/home',
	'/patterns',
	'/learn-more-trainer',
	'/learn-more-patterns',
]);

const normalizePath = (pathname) => {
	if (!pathname || pathname === '/') {
		return '/';
	}

	return pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
};

export const isSlideUpEnabledPath = (pathname) => animatedPaths.has(normalizePath(pathname));

const isSlideUpEnabled = () => {
	if (typeof window === 'undefined') {
		return true;
	}

	return isSlideUpEnabledPath(window.location.pathname);
};

const slideUpVariant = (enabledVariant, disabledVariant) => () => (
	isSlideUpEnabled() ? enabledVariant : disabledVariant
);

export const containerVariants = {
	hidden: { opacity: 0 },
	visible: { opacity: 1, transition: { duration: 0.8 } },
};

export const imageVariants = {
	hidden: { x: '-100vw' },
	visible: { x: 0, transition: { type: 'spring', stiffness: 50 } },
};

export const textVariants = {
	hidden: slideUpVariant({ y: 50, opacity: 0 }, { y: 0, opacity: 0 }),
	visible: slideUpVariant(
		{ y: 0, opacity: 1, transition: { duration: 0.6, delay: 0.3 } },
		{ y: 0, opacity: 1, transition: { duration: 0.6, delay: 0.3 } },
	),
};

export const textVariantsLearn = {
	hidden: slideUpVariant({ y: 50, opacity: 0 }, { y: 0, opacity: 0 }),
	visible: slideUpVariant(
		{ y: 0, opacity: 1, transition: { duration: 0.4 } },
		{ y: 0, opacity: 1, transition: { duration: 0.4 } },
	),
};

export const tileVariants = {
	hidden: slideUpVariant({ opacity: 0, y: 50 }, { opacity: 0, y: 0 }),
	visible: { opacity: 1, y: 0 },
};

export const sectionVariants = {
	hidden: slideUpVariant({ opacity: 0, y: 50 }, { opacity: 0, y: 0 }),
	visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};
